export default __webpack_public_path__ + "static/media/Armguards of the Beyond.40e3c636.jpg";